import { render, staticRenderFns } from "./requestSync.vue?vue&type=template&id=5736b453&scoped=true&"
import script from "./requestSync.vue?vue&type=script&lang=js&"
export * from "./requestSync.vue?vue&type=script&lang=js&"
import style0 from "./requestSync.vue?vue&type=style&index=0&id=5736b453&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5736b453",
  null
  
)

export default component.exports